import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';

export interface PageEventType {
  pageIndex: number;
  previousPageIndex: number;
  loader: number;
  size: number;
  // true  => fresh start: the parent REPLACES the dataset (batch-size change / page 0)
  // false => "Load More": the parent APPENDS the next page to the already-loaded rows
  isReset?: boolean;
}

@Component({
  selector: 'lc-custom-table-paginator',
  templateUrl: './lc-custom-table-paginator.component.html',
  styleUrls: ['./lc-custom-table-paginator.component.scss'],
})
export class LcCustomTablePaginatorComponent implements OnInit, OnChanges {
  @Input()
  paginatorLoaderTitle!: string;

  @Input()
  paginatorLoader: number = 50;

  @Input()
  paginatorLoaderList: Array<number> = [50, 100, 250];

  @Input()
  page!: number;

  @Input()
  numElementsLoaded!: number;

  @Input()
  numElementsSize!: number;

  isAllLoaded: boolean = false;

  @Output()
  onPaginatorChange: EventEmitter<PageEventType> = new EventEmitter<PageEventType>();

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(): void {}

  onPageChange(evt: any): void {
    // Changing the batch size restarts the incremental loading from the top:
    // reset to page 0 and request a full replace (isReset = true), so that subsequent
    // "Load More" calls stay aligned with the new batch size (offset = page * size).
    this.page = 0;
    this.isAllLoaded = false;
    this.onPaginatorChange.emit({
      pageIndex: this.page,
      previousPageIndex: -1,
      loader: this.paginatorLoader,
      size: this.numElementsSize,
      isReset: true,
    });
  }

  onLoadClick(event: MouseEvent): void {
    event.preventDefault();
    this.isAllLoaded = this.numElementsSize - this.numElementsLoaded <= 0;
    if (!this.isAllLoaded) {
      // Derive the next page from the rows actually loaded instead of an internal
      // counter: this keeps offset (page * loader) aligned right after the last loaded
      // row even when a filter/sort reload changed the loaded-row count.
      const nextPage = Math.floor(this.numElementsLoaded / this.paginatorLoader);
      this.page = nextPage;
      this.onPaginatorChange.emit({
        pageIndex: nextPage,
        previousPageIndex: nextPage - 1,
        loader: this.paginatorLoader,
        size: this.numElementsSize,
        isReset: false,
      });
    }
  }
}
